import { render, staticRenderFns } from "./invoice-internal-notes.vue?vue&type=template&id=31d52807&scoped=true"
import script from "./invoice-internal-notes.vue?vue&type=script&lang=js"
export * from "./invoice-internal-notes.vue?vue&type=script&lang=js"
import style0 from "./invoice-internal-notes.vue?vue&type=style&index=0&id=31d52807&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d52807",
  null
  
)

export default component.exports